import React from 'react';
import { TextAnalysis } from '../../../../utilities/sermonAnalyzer/SermonAnalyzer';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SolidIcon from '@material-ui/icons/Brightness1';
import {  ExpansionPanel, ExpansionPanelSummary, ListItem, Tooltip, ListItemText, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    panel: {
        boxShadow: 'none',
        margin: 0,
        paddingLeft: 0,
    },
    panelSummary: {
        color: "#000000de",
        textSize: '1rem',
    },
    expandIcon: {
        color: "#000000de",
        textSize: '15px',
    },
    categoryTitle: {
        color: "#000",
        fontWeight: 500,
        fontSize: "0.9rem",
    }
}));

interface Props {
    suggestions: TextAnalysis[];
    bulletColor: string;
    category: string;
}

export function AnalyzerTextSuggestionsPanel(props:Props) {
    const {suggestions, bulletColor, category} = props;
    const classes = useStyles();

    return(
        <ExpansionPanel className={classes.panel} defaultExpanded>
            <ExpansionPanelSummary style={{paddingLeft: 0}} expandIcon={<ExpandMoreIcon className={classes.expandIcon}/>}>
                <Typography className={classes.panelSummary}>{category} ({suggestions.length})</Typography>
            </ExpansionPanelSummary>
        {   suggestions.map( (suggestion, index) =>  
            <ListItem style={{ paddingBottom: 12, paddingLeft: 0,
            }} key={index}>
                <ListItemText primary={
                    <Typography variant='caption'>
                        <SolidIcon style={{ color: bulletColor, fontSize: 'small', marginRight: 10}} />
                        <Tooltip placement="top-start" title={suggestion.helperText}>
                        <span className={classes.categoryTitle}>
                            {suggestion.title}:
                        </span>
                        </Tooltip>
                        <span style={{ color: suggestion.color ? suggestion.color : undefined, fontSize: "0.9rem" }}> { suggestion.displayText }</span>                             
                    </Typography>
                }  />
            </ListItem>
        )}
        </ExpansionPanel>
    )
}